import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'videoOverlay';
const createActionName = name => `toi/${reducerName}/${name}`;

export const OPEN_OVERLAY = createActionName('OPEN_OVERLAY');
export const CLOSE_OVERLAY = createActionName('CLOSE_OVERLAY');
export const DOCK_OVERLAY = createActionName('DOCK_OVERLAY');
export const UNDOCK_OVERLAY = createActionName('UNDOCK_OVERLAY');
export const OPEN_VIDEO_OVERLAY_DOCKED_MODE = createActionName(
  'OPEN_VIDEO_OVERLAY_DOCKED_MODE',
);
export const TURN_DIM_ON = createActionName('TURN_DIM_ON');
export const TURN_DIM_OFF = createActionName('TURN_DIM_OFF');

export function openOverlay(videoData, docked) {
  return {
    type: OPEN_OVERLAY,
    payload: {
      videoData,
      isOverlayDocked: docked,
    },
  };
}

export function closeOverlay() {
  return {
    type: CLOSE_OVERLAY,
    payload: {},
  };
}
export function dockOverlay() {
  return {
    type: DOCK_OVERLAY,
    payload: {},
  };
}
export function unDockOverlay() {
  return {
    type: UNDOCK_OVERLAY,
    payload: {},
  };
}

export function openOverlayDockedMode() {
  return {
    type: OPEN_VIDEO_OVERLAY_DOCKED_MODE,
    payload: {},
  };
}

export function turnDimOn() {
  return {
    type: TURN_DIM_ON,
    payload: {},
  };
}
export function turnDimOff() {
  return {
    type: TURN_DIM_OFF,
    payload: {},
  };
}
export default function reducer(state = {}, action) {
  switch (action.type) {
    case DOCK_OVERLAY:
      return {
        ...state,
        isOverlayDocked: true,
      };
    case UNDOCK_OVERLAY:
      return {
        ...state,
        isOverlayDocked: false,
      };
    case CLOSE_OVERLAY:
      return {
        ...state,
        isOverlayOpen: false,
        isOverlayDocked: false,
      };
    case OPEN_OVERLAY:
      return {
        ...state,
        isOverlayOpen: true,
        isOverlayDocked: false,
        videoData: action.payload.videoData,
      };
    case OPEN_VIDEO_OVERLAY_DOCKED_MODE:
      return {
        ...state,
        isOverlayOpen: true,
        isOverlayDocked: true,
        videoData: action.payload.videoData || state.videoData,
      };
    case TURN_DIM_ON:
      return {
        ...state,
        isDimOn: true,
      };
    case TURN_DIM_OFF:
      return {
        ...state,
        isDimOn: false,
      };

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
